import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCaretDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.83 12.625c.554.84 1.788.84 2.342 0L13.8 7.127A1.404 1.404 0 0 0 12.63 4.95H5.373a1.404 1.404 0 0 0-1.171 2.177z"
    />
  </svg>
);
export default SvgCaretDown;
